import { useTranslation } from "react-i18next"

import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface ClarificationRequestFormHintProps {
  onClose: () => void
}

export function ClarificationRequestFormHint({
  onClose
}: ClarificationRequestFormHintProps) {
  const { t } = useTranslation()

  return (
    <Hint.Root>
      <Hint.Icon name={IconName.INFO} />
      <Hint.Content>
        <Hint.Title>{t("ClarificationRequest.Form.Hint.Title")}</Hint.Title>
        <Hint.Text>{t("ClarificationRequest.Form.Hint.Text")}</Hint.Text>
      </Hint.Content>
      <Hint.Close
        onClick={onClose}
        label={t("ClarificationRequest.Form.Hint.Close")}
      />
    </Hint.Root>
  )
}
